import { FC } from 'react';
import { useInvoiceItemTabSettings } from '../../../Documents/Invoice/InvoiceCreator/InvoiceItemCreator/useInvoiceItemTabSettings';
import { GridFontSettingsModal } from './GridFontSettingsModal';
import { ModalSizeSettingsModal } from './ModalSizeSettingsModal';


interface IUISettingsEditModalProps {
    cancel: () => void;
    settingsName: string | undefined;
}

//Обёртка для ПН
const InvoiceItemTabSettingsModal: FC<{ onClose: () => void }> = ({ onClose }) => {
    const { SettingsModal } = useInvoiceItemTabSettings({
        initiallyOpen: true,
        onClose,
    });

    return <>{SettingsModal}</>;
};

// Реестр
const SETTINGS_FORMS: Record<string, FC<{ onClose: () => void }>> = {
    invoiceItemCreator: InvoiceItemTabSettingsModal,
    gridFont:           GridFontSettingsModal,
    modalSize:           ModalSizeSettingsModal,
};



export const UISettingsEditModal: FC<IUISettingsEditModalProps> = (props) => {
    if (!props.settingsName) return null;

    const Form = SETTINGS_FORMS[props.settingsName];

    if (!Form) {
        console.warn(`Нет формы настроек для "${props.settingsName}"`);
        return null;
    }

    return <Form onClose={props.cancel} />;
};